<!-- /**
* 工人详情页-个人资产
*/ -->
<template>
  <div class="personalAssetsList">
    <div v-if="sbData && sbData.length">
      <div>
        <div class="title-text">
          <div class="info-item-tt">自有设备</div>
        </div>
        <el-table :data="sbData" border style="border-right:0">
          <el-table-column prop="name" label="机械设备名称"> </el-table-column>
          <el-table-column prop="specification" label="规格型号" />
          <el-table-column prop="count" label="设备数量" />
          <el-table-column prop="url" label="设备图片">
            <template slot-scope="scope">
              <template v-if="scope.row.url">
                <el-image
                  style="
                    width: 40px;
                    height: 40px;
                    margin-right: 10px;
                    vertical-align: middle;
                  "
                  :src="scope.row.url[0].fileUrl"
                  fit="cover"
                  :preview-src-list="[scope.row.url[0].fileUrl]"
                ></el-image>
              </template>
              <div slot="error" v-else>
                <span>/</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="clData && clData.length">
      <div>
        <div class="title-text" style="margin-top: 15px">
          <div class="info-item-tt">自有材料</div>
        </div>
        <el-table :data="clData" border style="border-right:0">
          <el-table-column prop="name" label="材料名称"> </el-table-column>
          <el-table-column prop="specification" label="规格型号" />
          <el-table-column prop="count" label="材料数量" />
          <el-table-column prop="url" label="材料图片">
            <template slot-scope="scope">
              <template v-if="scope.row.url">
                <el-image
                  style="
                    width: 40px;
                    height: 40px;
                    margin-right: 10px;
                    vertical-align: middle;
                  "
                  :src="scope.row.url[0].fileUrl"
                  fit="cover"
                  :preview-src-list="[scope.row.url[0].fileUrl]"
                ></el-image>
              </template>
              <div slot="error" v-else>
                <span>/</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <BaseEmptyData
      isDetail
      v-if="
        !(sbData && sbData.length) && !(clData && clData.length) && !loadingTrue
      "
    ></BaseEmptyData>
  </div>
</template>

<script>
export default {
  name: "personalAssetsList",
  inject: ["reload"], // 引入App.vue 中的刷新页面的方法
  props: {
    clData: {
      type: Array,
      default: []
    },
    sbData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {}
  },
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData") // 暂无数据缺省图
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.personalAssetsList {
  .title-text {
    display: flex;
    width: 100%;
    align-items: center;
    border-bottom: 1px dashed #e5e5e5;
    justify-content: space-between;
    margin-bottom: 10px;
    .info-item-tt {
       color: #b79255;
      font-size: 18px;
      height: 15px;
      padding-left: 10px;
      border-left: 3px solid #b79255;
      line-height: 15px;
      margin-bottom: 10px;
    }
  }
  /deep/.el-table th.el-table__cell > .cell {
    height: 44px;
    line-height: 44px;
  }
  /deep/.el-table .el-table__cell {
    padding: 0;
  }
  /deep/tbody .el-table__row{
    height: 50px;
  }
}
</style>
